module.exports = __webpack_public_path__ + "img/loop.2ad76fbd.gif";